var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 68,
    viewBox: "0 0 319 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2425_637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0002 44.5H31.7002V67.8H55.0002V44.5Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5002 0.199951H0.200195V21.2H23.5002H31.7002V0.199951H23.5002Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4002 0.199951H63.1002L43.3002 21.2H31.7002V44.5L54.9002 21.2H63.1002H86.4002V0.199951Z",
    fill: "#EAEAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.4 15.8001H117.8V8.70007H155.4V15.8001H140.8V59.3001H132.3V15.8001H132.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.2 47.4001C151.2 40.0001 156.5 36.6001 168 35.5001L180.7 34.2001C180.5 27.6001 178.3 24.9001 170.2 24.9001C162.1 24.9001 160.6 27.9001 160.6 33.0001H152.4C152.4 24.7001 155.9 18.2001 170.1 18.2001C184.3 18.2001 189 25.3001 189 36.2001V59.2001H184.4L182.7 53.1001C180.8 56.3001 175.2 59.7001 166.8 59.7001C158.4 59.7001 151.1 55.8001 151.1 47.3001L151.2 47.4001ZM169 53.2001C177.1 53.2001 180.8 48.9001 180.8 41.9001V40.6001L169.3 41.9001C162.3 42.7001 159.9 44.2001 159.9 47.4001C159.9 50.6001 163.1 53.3001 169 53.3001V53.2001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.3 18.8H200.8L202.8 24.4C205.3 19.2 210 17.8 217.2 18.2V25.6C208.9 24.4 204.8 28.4 204.8 37.9V59.3H196.3V18.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.4 39C219.4 28.2 223.5 18.3 239.6 18.3C255.7 18.3 258.7 29.7001 257.7 42.4001H228.1C228.6 49.4001 232.1 53.4001 239.3 53.4001C246.5 53.4001 248.2 50.2001 248.9 46.9001H257.8C257.1 53.8001 252.3 59.9001 239.6 59.9001C226.9 59.9001 219.3 49.9 219.3 39H219.4ZM249 35.7001V35.5C249 30 246.5 24.8 238.8 24.8C231.1 24.8 228.6 29.7 228.2 35.6H249V35.7001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.7 3.40002H273.2V59.3H264.7V3.40002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3 32.9001C318 31.0001 317.3 29.1 316.4 27.3C315.5 25.4 314.3 23.9 312.8 22.6C311.3 21.3001 309.4 20.2 307.1 19.5C304.8 18.7 302.2 18.3 299.2 18.3C296.2 18.3 293.6 18.7 291.3 19.5C289 20.3 287.1 21.3001 285.6 22.6C284.1 23.9 282.9 25.5 282 27.3C281.1 29.1 280.4 31.0001 280.1 32.9001C279.8 34.8001 279.6 36.8 279.6 39C279.6 41.2 279.8 43.3001 280.1 45.2001C280.4 47.1001 281.1 49 282 50.8C282.9 52.6 284.1 54.2 285.6 55.5C287 56.8 289 57.8 291.3 58.6C293.6 59.4 296.2 59.8 299.2 59.8C312.2 59.8 318.8 52.8 318.8 39C318.8 25.2 318.6 34.7001 318.3 32.9001ZM308.7 49.2001C307.9 50.5001 306.7 51.5 305.1 52.1C303.5 52.8 301.5 53.2001 299.2 53.2001C296.9 53.2001 294.9 52.8 293.4 52.1C291.9 51.4 290.7 50.4 289.9 49.1C289.1 47.8 288.4 46.3001 288.1 44.7001C287.7 43.1001 287.6 41.2 287.6 39.1C287.6 37 287.8 35.1 288.2 33.5C288.6 31.9 289.2 30.4 290 29.1C290.8 27.8001 292 26.9001 293.5 26.2001C295.1 25.5001 297.1 25.1 299.4 25.1C301.7 25.1 303.7 25.5001 305.3 26.2001C306.9 26.9001 308 27.9001 308.8 29.2001C309.6 30.5001 310.3 32 310.6 33.6C311 35.2 311.1 37.1001 311.1 39.2001C311.1 41.3001 310.9 43.2001 310.6 44.9001C310.2 46.5001 309.6 48 308.8 49.3L308.7 49.2001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 319,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.9e610d11.svg";
export { ForwardRef as ReactComponent };